class WishlistDrawer extends HTMLElement {
  constructor() {
    super();

    this.empty = this.querySelector('.wishlist-drawer__empty');
    this.content = this.querySelector('.wishlist-drawer__content');
    this.items = this.querySelector('.wishlist-drawer__items');
    this.settings = this.getAttribute('data-settings') || '';
    this.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
    this.setWishlistLinkAccessibility();
    this.renderContents();

    window.addEventListener('wishlistUpdated', (event) => {
      this.renderContents();
      if (event.detail?.target?.classList.contains('active') && !event.detail.target.classList.contains('delete-item-button')) {
        this.open(event.detail.target);
      }
    });
  }

  setWishlistLinkAccessibility() {
    document.querySelectorAll('[data-wishlist-drawer-open]').forEach((wishlistLink) => {
      wishlistLink.setAttribute('role', 'button');
      wishlistLink.setAttribute('aria-haspopup', 'dialog');
      wishlistLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(wishlistLink);
      });
      wishlistLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(wishlistLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;
    this.renderContents();
    setTimeout(() => {
      this.classList.add('active');
      this.classList.add('animate');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.empty : document.getElementById('WishlistDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.popup-modal__toggle');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    if (document.querySelectorAll('.popup-modal.active').length === 0) {
      document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
      document.body.classList.add('overflow-hidden');
    }
  }

  close() {
    this.classList.remove('animate');
    setTimeout(() => {
      this.classList.remove('active');
      if (document.querySelectorAll('.popup-modal.active').length === 0) {
        document.body.classList.remove('overflow-hidden');
        document.body.style.paddingRight = '';
      }
    }, 500);
    removeTrapFocus(this.activeElement);
  }

  renderContents() {
    const existingData = localStorage.getItem('productDataWishlist');
    if (!existingData) {
      this.classList.add('is-empty');
      this.empty.classList.remove('hide');
      this.content.classList.add('hide');
      if (this.items) this.items.innerHTML = '';
      return;
    }

    let dataMap = {};
    try {
      dataMap = JSON.parse(existingData);
    } catch (error) {
      localStorage.removeItem('productDataWishlist');
      this.renderContents();
      return;
    }

    const handles = Object.values(dataMap).filter(Boolean).join('||');
    if (!handles) {
      localStorage.removeItem('productDataWishlist');
      this.renderContents();
      return;
    }

    this.classList.remove('is-empty');
    this.empty.classList.add('hide');
    this.content.classList.remove('hide');
    this.load(`${handles}||`);
  }

  load(handles) {
    fetch(`${window.routes.all_products_collection_url}?view=wishlist_ajax&sort_by=${handles}${this.settings}`)
      .then((response) => response.text())
      .then((responseText) => {
        if (!responseText.trim()) {
          localStorage.removeItem('productDataWishlist');
          this.renderContents();
          window.dispatchEvent(new CustomEvent('wishlistUpdated', { detail: { target: this } }));
          return;
        }
        this.items.innerHTML = responseText;
      });
  }

  getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }
}

customElements.define('wishlist-drawer', WishlistDrawer);
